const CaseStatsFilters = ({
  filterOptions,
  filters,
  setFilters,
  onApply,
  onReset,
  loading,
  onFilterChange,
}) => {
  const handleChange = (field, value) => {
    const newFilters = {
      ...filters,
      [field]: value,
    };

    // Reset dependent filters when parent filter changes
    if (field === "court") {
      newFilters.diadikasia = "";
      newFilters.antikeimeno = "";
      // Fetch updated filter options based on selected court
      onFilterChange(value, "");
    } else if (field === "diadikasia") {
      newFilters.antikeimeno = "";
      // Fetch updated filter options based on selected court and diadikasia
      onFilterChange(filters.court, value);
    }

    setFilters(newFilters);
  };

  return (
    <div className="bg-white rounded-lg shadow p-6">
      <h2 className="text-lg font-semibold text-gray-900 mb-4">Φίλτρα</h2>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {/* Court Filter */}
        <div>
          <label
            htmlFor="court"
            className="block text-sm font-medium text-gray-700 mb-1"
          >
            Δικαστήριο
          </label>
          <select
            id="court"
            value={filters.court}
            onChange={(e) => handleChange("court", e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
            disabled={loading}
          >
            <option value="">Όλα</option>
            {filterOptions.courts.map((court) => (
              <option key={court} value={court}>
                {court}
              </option>
            ))}
          </select>
        </div>

        {/* Diadikasia Filter */}
        <div>
          <label
            htmlFor="diadikasia"
            className="block text-sm font-medium text-gray-700 mb-1"
          >
            Διαδικασία
          </label>
          <select
            id="diadikasia"
            value={filters.diadikasia}
            onChange={(e) => handleChange("diadikasia", e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
            disabled={loading}
          >
            <option value="">Όλες</option>
            {filterOptions.diadikasies.map((diadikasia) => (
              <option key={diadikasia} value={diadikasia}>
                {diadikasia}
              </option>
            ))}
          </select>
        </div>

        {/* Antikeimeno Filter */}
        <div>
          <label
            htmlFor="antikeimeno"
            className="block text-sm font-medium text-gray-700 mb-1"
          >
            Αντικείμενο
          </label>
          <select
            id="antikeimeno"
            value={filters.antikeimeno}
            onChange={(e) => handleChange("antikeimeno", e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
            disabled={loading}
          >
            <option value="">Όλα</option>
            {filterOptions.antikeimena.map((antikeimeno) => (
              <option key={antikeimeno} value={antikeimeno}>
                {antikeimeno}
              </option>
            ))}
          </select>
        </div>

        {/* Date From */}
        <div>
          <label
            htmlFor="dateFrom"
            className="block text-sm font-medium text-gray-700 mb-1"
          >
            Από Ημερομηνία
          </label>
          <input
            type="date"
            id="dateFrom"
            value={filters.dateFrom}
            onChange={(e) => handleChange("dateFrom", e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
            disabled={loading}
          />
        </div>

        {/* Date To */}
        <div>
          <label
            htmlFor="dateTo"
            className="block text-sm font-medium text-gray-700 mb-1"
          >
            Έως Ημερομηνία
          </label>
          <input
            type="date"
            id="dateTo"
            value={filters.dateTo}
            onChange={(e) => handleChange("dateTo", e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
            disabled={loading}
          />
        </div>

        {/* Action Buttons */}
        <div className="flex items-end gap-2">
          <button
            onClick={onApply}
            disabled={loading}
            className="flex-1 bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:bg-gray-400 disabled:cursor-not-allowed"
          >
            Εφαρμογή
          </button>
          <button
            onClick={onReset}
            disabled={loading}
            className="flex-1 bg-gray-200 text-gray-700 px-4 py-2 rounded-md hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 disabled:bg-gray-100 disabled:cursor-not-allowed"
          >
            Επαναφορά
          </button>
        </div>
      </div>
    </div>
  );
};

export default CaseStatsFilters;
